import React from "react";
import ModalWithButtons from "components/molecules/Modal/ModalWithButtons";
import translations from "translations";
import { zerezIdFontStyle } from "utils/zerezIdStyle";

export interface ChainCertificate {
  certificateId: string;
  certificateNumber: string;
  certificateCode: string;
  chainLevel: number;
}

interface CertificateChainWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  chainCertificates: ChainCertificate[];
  currentCertificateId: string;
  context: "edit" | "replace";
}

const CertificateChainWarningModal: React.FC<CertificateChainWarningModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  chainCertificates,
  currentCertificateId,
  context,
}) => {
  // Determine text and button labels based on context
  const isEditContext = context === "edit";
  const description = isEditContext
    ? translations.pages.certificationManagement.certificateChainWithdrawWarningDescription
    : translations.pages.certificationManagement.certificateChainReplaceWarningDescription;

  const confirmButtonText = isEditContext
    ? translations.pages.certificationManagement.certificateChainWithdrawWarningConfirm
    : translations.pages.certificationManagement.certificateChainReplaceWarningConfirm;

  return (
    <ModalWithButtons
      openModal={isOpen}
      onClose={onClose}
      title={translations.pages.certificationManagement.certificateChainWithdrawWarningTitle}
      addButtonTitle={confirmButtonText}
      addButtonClick={onConfirm}
      cancelTitle={translations.pages.certificationManagement.certificateChainWithdrawWarningCancel}
      width="600px"
    >
      <div>
        <p>{description}</p>
        {chainCertificates.length > 0 && (
          <div style={{ marginTop: "16px" }}>
            <strong>{translations.pages.certificationManagement.certificateChainList}:</strong>
            <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
              {chainCertificates.map((cert, index) => {
                const isCurrentCertificate = cert.certificateId === currentCertificateId;
                const isBaseCertificate = chainCertificates.length > 0 && cert.chainLevel === 0; // Base certificate has chainLevel 0
                const numberText = `${cert.certificateNumber}${isBaseCertificate ? " (Base)" : ""}`;

                return (
                  <li key={cert.certificateCode || `cert-${index}`} style={{ marginBottom: "4px" }}>
                    {isCurrentCertificate ? <strong>{numberText}</strong> : numberText}
                    {cert.certificateCode && (
                      <span style={zerezIdFontStyle}>
                        {isCurrentCertificate ? (
                          <strong>{` (${cert.certificateCode})`}</strong>
                        ) : (
                          ` (${cert.certificateCode})`
                        )}
                      </span>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    </ModalWithButtons>
  );
};

export default CertificateChainWarningModal;
